import { render, staticRenderFns } from "./ShowStory.vue?vue&type=template&id=0bbacc96"
import script from "./ShowStory.vue?vue&type=script&lang=js"
export * from "./ShowStory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports